<template>
  <div class="nammer-hero">
    <video
      v-if="bannerHome.tipo == 2"
      :key="isDesktop"
      :src="isDesktop ? bannerHome.imagen_desktop : bannerHome.imagen_movil"
      autoplay
      loop
      playsinline
      muted
      preload="auto"
    />
    <picture v-else>
      <source
        :srcset="bannerHome.imagen_desktop"
        width="1920"
        media="(min-width: 768px)"
      />
      <source
        :srcset="bannerHome.imagen_movil"
        width="100%"
        media="(max-width: 768px)"
      />
      <img
        class="hero_banner__img"
        :src="bannerHome.imagen_desktop"
        fetchpriority="high"
        loading="eager"
      />
    </picture>
    <div class="nammer-hero__content">
      <div class="content_hero">
        <p
          v-if="bannerHome.subtitulo"
          :style="bannerHome.style_subtitulo"
          class="text-banner_hero"
          v-html="bannerHome.subtitulo"
        />
        <div
          v-if="bannerHome.titulo"
          class="text-banner_hero"
          :style="bannerHome.style_titulo"
          v-html="bannerHome.titulo"
        />
        <p
          v-if="bannerHome.descripcion"
          :style="bannerHome.style_descripcion"
          class="text-banner_hero"
          v-html="bannerHome.descripcion"
        />
        <button class="btn_action" @click="clicBtn(bannerHome.boton.texto)">
          {{ bannerHome.boton.texto }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('layouts', ['bannerHome']),
    ...mapState(['innerWidth']),
    isDesktop() {
      return this.innerWidth > 768
    },
  },
}
</script>
<style scoped>
.nammer-hero {
  position: relative;
  height: 100svh;
  width: 100%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  video,
  picture {
    height: 100vh;
    width: 100%;
    object-fit: cover;
  }
  .hero_banner__img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
  .nammer-hero__content {
    width: 100%;
    position: absolute;
    padding: 3rem 1.5rem;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    text-align: center;
    min-height: 40vh;
    background: linear-gradient(transparent, rgba(0, 0, 0, 0.5));
    .content_hero {
      max-width: 450px;
      .btn_action {
        padding: 0.6rem 1.2rem;
        background: transparent;
        color: white;
        border: none;
        box-shadow: inset 0 0 0 1px #fff;
        transition: all 0.2s ease-in-out;
        &:hover {
          box-shadow: inset 0 0 0 2px #fff;
        }
      }
    }
  }
}
</style>
